module.exports = __webpack_public_path__ + "img/export-redownload.adcd134a.svg";